var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewer',{staticClass:"image-container",attrs:{"images":_vm.images}},_vm._l((_vm.images),function(item){return _c('img',{key:item.index,staticClass:"image",attrs:{"alt":"图片","src":item.src},on:{"load":_vm.onImageLoad}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }